import PocketBase from 'pocketbase';

// Initialise le client PocketBase avec l'URL de votre instance
const pb = new PocketBase('https://couleursirene.infocolab.online');

// ✅ Désactive l’auto-annulation des requêtes identiques (évite l’erreur "The request was autocancelled")
pb.autoCancellation(false);

// ✅ Persistance de l’authentification dans les cookies
try {
  pb.authStore.loadFromCookie(document.cookie);
} catch (_) {
  // ignore en cas de cookie invalide
}

// À chaque changement d’auth, on ré-écrit le cookie côté navigateur
pb.authStore.onChange(() => {
  document.cookie = pb.authStore.exportToCookie({
    httpOnly: false,
    sameSite: 'Lax',
    secure: window.location.protocol === 'https:',
    path: '/',
  });
});

export default pb;
